<script>
import { mapGetters } from "vuex";
import { scroller } from "vue-scrollto/src/scrollTo";
import {
  MDBContainer,
  MDBRow,
  MDBCol,
} from "mdb-vue-ui-kit";

import clientConfig from "/src/config/client";

export default {
  name: "NextPanel",

  components: {
    MDBContainer,
    MDBRow,
    MDBCol,
  },

  data() {
    return {
      clientConfig,
    };
  },

  computed: {
    ...mapGetters([
      "debugMode"
    ])
  },

  methods: {
    triggerHeightCheck() {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function () {
        rf.$refreshIframeHeight();
      }, 300);
    },

    clickToTab(tabNum) {
      const scrollTo = scroller();
      this.$store.commit("setActiveTab", tabNum);
      scrollTo("#ccApp");
      
      this.triggerHeightCheck();
      
      this.$gtag.event('click', {
        'event_category': 'navigation',
        'event_label': 'navigateTo' + tabNum,
        'value': 1
      });
      
      if (this.debugMode)
        console.log("GTAG Event: navigateTo" + tabNum);
    },
  },

  mounted() {
    this.triggerHeightCheck();
  },
};
</script>

<template>
  <MDBContainer fluid>
    <MDBRow class="p-0">
      <MDBCol md="11" class="main-content-wrapper">
        <div v-html="clientConfig.content.whatsnext.header"></div>
        <div v-html="clientConfig.content.whatsnext.content"></div>

        <!-- // -->

        <!-- <div class="welcome-container">
          <div class="info-text-content">
            <div class="link-section-wrapper">
              <a
                class="section"
                href="https://www.supersa.sa.gov.au/"
                target="_blank"
                ><i class="cta-icon"
                  ><img alt="" src="@/assets/images/grow-your-super-white.svg"
                /></i>
                <h4>Do a salary sacrifice <br>(before tax contributions)</h4></a
              ><a
                class="section"
                href="https://www.supersa.sa.gov.au/financial-planning/"
                target="_blank"
                ><i class="cta-icon"
                  ><img alt="" src="@/assets/images/seek-financial-advice-white.svg"
                /></i>
                <h4>Seek financial advice</h4></a
              >
            </div>
            <div class="link-section-wrapper">
              <a
                class="section"
                href="https://www.supersa.sa.gov.au/"
                target="_blank"
                ><i class="cta-icon"
                  ><img alt="" src="@/assets/images/consolidate-white.svg"
                /></i>
                <h4>Do an after tax contributions</h4></a
              ><a
                class="section"
                href="https://www.supersa.sa.gov.au/tools-and-resources/webinars-and-seminars/"
                target="_blank"
                ><i class="cta-icon"
                  ><img alt="" src="@/assets/images/seminars-white.svg"
                /></i>
                <h4>Register for a webinar</h4></a
              >
            </div>
            <div class="info-text-follow-up-content">
              <div class="welcome-continue-box pt-4">
                <h3>We're here to help.</h3>
                <p>
                  If you have any questions please contact our local member
                  services team on
                  <a href="tel:1300-369-315"><strong>1300 369 315</strong></a>
                  or
                  <a
                    href="mailto:&#115;&#117;&#112;&#101;&#114;&#115;&#097;&#064;&#115;&#097;&#046;&#103;&#111;&#118;&#046;&#097;&#117;"
                    >email</a
                  >
                  &#115;&#117;&#112;&#101;&#114;&#115;&#097;&#064;&#115;&#097;&#046;&#103;&#111;&#118;&#046;&#097;&#117;
                </p>
              </div>
            </div>
          </div>
        </div> -->
      </MDBCol>
    </MDBRow>
  </MDBContainer>
</template>
